import React, {useCallback, useEffect, useState} from 'react';
import {
  ActivityIndicator,
  FlatList,
  Text,
  View,
  Modal,
  Pressable,
  ScrollView,
} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import ButtonComponent from '../../components/ButtonComponent/ButtonComponent';
import Header from '../../components/Header/Header';
import SearchHeader from '../../components/SearchHeader/SearchHeader';
import EquipamentsService from '../../services/EquipamentsService/EquipamentsService';
import EquipamentResume from './components/EquipmentResume/EquipmentResume';
import NotEquipament from './components/NotEquipament/NotEquipament';
import ErrorEquipament from './components/ErrorEquipament/ErrorEquipament';
import {styles} from './styles';
import {NavigationProps} from '../../navigation/Routes';
import {AppRoutes} from '../../navigation/Routes.types';
import {useUserStore} from '../../store/UserStore';
import {ISolicitation} from '../../types/Equipaments';
import {Colors} from '../../constants/Colors';
import EquipmentTermsModal from '../../components/EquipmentTermsModal/EquipmentTermsModal';
import {useIsDesktop} from '../../hooks/useIsDesktop';

const Equipament = ({route}: {route: any}) => {
  const isDesktop = useIsDesktop();
  const {goBack, navigate} = useNavigation<NavigationProps>();
  const [equipamentData, setEquipamentData] = useState<ISolicitation[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [refreshing, setRefreshing] = useState<boolean>(false); // Pull-to-refresh
  const [errorEquipment, setErrorEquipment] = useState<boolean>(false);
  const [notEquipmentMessage, setNotEquipmentMessage] = useState<string>('');
  const {user} = useUserStore();
  const [termsVisible, setTermsVisible] = useState(false);

  const GetEquipaments = useCallback(
    async (force = false) => {
      setLoading(true);
      setErrorEquipment(false);
      setEquipamentData([]);
      try {
        const response = !!force
          ? await EquipamentsService.UpdatedEquipamentsGet(user?.clientCode)
          : await EquipamentsService.EquipamentsGet(user?.clientCode);
        if (response?.details) {
          setEquipamentData([]);
          setNotEquipmentMessage(response.details);
          return;
        }
        setEquipamentData(response || []);
      } catch (error) {
        setErrorEquipment(true);
      } finally {
        setLoading(false);
      }
    },
    [user?.clientCode],
  );

  // Pull-to-refresh
  const handleRefresh = async () => {
    setRefreshing(true);
    await GetEquipaments(true);
    setRefreshing(false);
  };

  const renderItem = ({item, index}: {item: ISolicitation; index: number}) => (
    <EquipamentResume
      key={index}
      name={item?.MAKTX}
      status={item?.STATUS}
      date={item?.ERDAT}
      item={item}
    />
  );

  useEffect(() => {
    GetEquipaments();
  }, [GetEquipaments]);

  return (
    <View
      style={[styles.container, {marginBottom: isDesktop ? 0 : (!user?.storeAccess ? 85 : 0)}]}>
      <FlatList
        data={equipamentData}
        renderItem={renderItem}
        keyExtractor={(item, index) => 'key' + index}
        refreshing={refreshing}
        onRefresh={handleRefresh}
        ListHeaderComponent={
          <>
            <Header />
            <View style={styles.spaceTop}>
              <SearchHeader onPress={goBack} title="Equipamentos" mb={10} />
            </View>
            <Text style={styles.info}>Informações dos seus equipamentos</Text>
            <View style={styles.containerFilter}>
              <Text style={styles.products}>Equipamentos</Text>
            </View>
          </>
        }
        ListFooterComponent={
          <View style={{marginBottom: 20}}>
            <View style={styles.containerButton}>
              <ButtonComponent
                title="Solicite aqui!"
                width="100%"
                onPress={() => navigate(AppRoutes.REQUEST_EQUIPMENT_LIST)}
              />
            </View>
            {equipamentData.length >= 1 && (
              <View style={[styles.containerButton, {marginTop: 10}]}>
                <ButtonComponent
                  title="Solicitar Manutenção"
                  width="100%"
                  outlined
                  onPress={() => navigate(AppRoutes.EQUIPMENT_MAINTENANCE_LIST)}
                />
              </View>
            )}
          </View>
        }
        ListEmptyComponent={
          loading ? (
            <ActivityIndicator color={Colors.RedPallete.red} size={20} />
          ) : errorEquipment ? (
            <ErrorEquipament title="Ops.. Erro ao buscar seus equipamentos. Tente novamente mais tarde." />
          ) : (
            <NotEquipament
              title={notEquipmentMessage || 'Nenhum equipamento encontrado'}
            />
          )
        }
      />

      <Pressable onPress={() => setTermsVisible(true)}>
        <Text style={styles.termsLink}>
          Termos de uso de aluguel de equipamentos
        </Text>
      </Pressable>

      <EquipmentTermsModal
        termsVisible={termsVisible}
        setTermsVisible={setTermsVisible}
        type={1}
      />
    </View>
  );
};

export default Equipament;
